import { Component, State, h, Prop, Watch } from '@stencil/core';
import { getCategory, getSorterV2 } from '@ugc-api/question';
import { IFilter, defaultSort } from '@ugc-components/ugc-pdp-question-and-answer/interfaces';
import { requestListData } from '@ugc-components/ugc-pdp-question-and-answer/utils';
import state from '@ugc-store';
import { debounce } from '@ugc-utils/utils';
import ViewDesktop from './view.desktop';
import ViewMobile from './view.mobile';

@Component({
  tag: 'ugc-qna-filter',
  shadow: false,
})
export class UgcQnaFilter {
  @Prop() productId: number;
  @State() isPadSize = false;

  constructor() {
    this.onSearchChange = debounce(this.onSearchChange, 1000);
  }
  onSearchChange = () => {
    requestListData();
  };
  async getCategoryList(language) {
    try {
      const data = (await getCategory(language)) as Array<IFilter>;
      if (data.length) {
        const categoryList = data.map(({ id, name }) => ({
          id,
          name,
        }));
        state.categoryList = categoryList;
      }
    } catch (e) {}
  }
  async getSorterList(language) {
    try {
      const data = (await getSorterV2(language)) as Array<IFilter>;
      if (data.length) {
        const sorterList = data.map(({ id, name }) => ({
          id,
          name,
        }));
        state.sorterList = sorterList;
      }
    } catch (e) {}
  }

  resetFilter() {
    state.sortId = defaultSort;
    state.cid = 0;
    state.textToSearch = '';
  }
  componentWillLoad() {
    const {
      preference: { language },
    } = state;
    this.resetFilter();
    this.getCategoryList(language);
    this.getSorterList(language);
    this.setPadSizeBoolean();
    window.onresize = debounce(() => this.setPadSizeBoolean(), 100);
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.resetFilter();
  }

  setPadSizeBoolean() {
    const padMaxSize = 1000;
    this.isPadSize = window.innerWidth < padMaxSize;
  }
  onInput({ detail }) {
    const textToSearch = detail.trim();
    state.textToSearch = textToSearch;
    textToSearch === '' ? requestListData() : this.onSearchChange();
  }
  onSortSelectList({ detail = 5 }) {
    state.sortId = detail;
    requestListData();
  }
  onFilterSelectList({ detail = 0 }) {
    state.cid = detail;
    requestListData();
  }

  render() {
    return state.isDesktop ? (
      <ViewDesktop
        isPadSize={this.isPadSize}
        onInput={this.onInput.bind(this)}
        onSortSelectList={this.onSortSelectList.bind(this)}
        onFilterSelectList={this.onFilterSelectList.bind(this)}
      />
    ) : (
      <ViewMobile onInput={this.onInput.bind(this)} />
    );
  }
}
